export const useValidation = () => {
  const isEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    return !!email.match(regex)
  }

  const isPasswordStrong = (password: string) => {
    return password?.match(/[A-Z]/) && password?.match(/[a-z]/) && password?.length >= 8 && password?.length <= 100
  }

  return { isEmail, isPasswordStrong }
}
